// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/toolbar/index.less
// module id = 86
// module chunks = 0